// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o888p","left":"styles_left__33Bw4"};